var exports = {
  "q": "AttachmentSingleMedia.module__relativeWrapper___VUpiTm",
  "u": "AttachmentSingleMedia.module__singleMediaContainer___VUpiTm",
};

module.exports = exports;
